import React from "react";

import { Container, Row, Col, Button } from "reactstrap";
import { Helmet } from "react-helmet";

import NavbarPrimary from "../sections/NavbarPrimary.js";
import Footer from "../sections/Footer.js";
import SwrccuHeader from "../headers/SwrccuHeader.js";
import PreFooter from "../sections/PreFooter.js";
import IntelMain from "../blogs/IntelMain.js";

function Intel() {
  const style = { width: "100%" };
  React.useEffect(() => {
    document.body.classList.add("index");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    let href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    if (
      window.location.href.lastIndexOf("#") > 0 &&
      document.getElementById(href)
    ) {
      document.getElementById(href).scrollIntoView();
    }
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      <Helmet>
        <title>CrypTegridy - SWRCCU Conference</title>
        <meta name="description" content="An in-depth analysis of the SWRCCU Conference and its implications for the cyber security industry." />
        <meta name="keywords" content="CrypTegridy, SWRCCU, conference, cyber security, protection, intelligence" />
      </Helmet>
      <NavbarPrimary />
      <div className="wrapper">
        <Button
          className="btn-icon-only back-to-top text-lowercase text-default show"
          color="info"
          name="button"
          type="button"
          onClick={() => {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
          }}
        >
          &alpha;
        </Button>
        <SwrccuHeader />
        <section className="section">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="8">
                <h6 className="category">January 21, 2024</h6>
                <h3 className="title">
                  The Importance of Cyber Security for Businesses
                </h3>
                <p className="font-weight-normal">
                  The event addressed the problem of increasing cyber breaches and threats that businesses face, 
                  regardless of their size. Protecting digital information and data starts with maintaining physical 
                  security. Even with the most sophisticated software and security measures in place, a simple 
                  mistake by one person could have a catastrophic impact on your whole organization.
                </p>
                <p className="font-weight-normal">
                  We had the pleasure to listen to a very insightful panel of expert speakers sharing their knowledge 
                  and advising on how to spot cyber attack and build cyber resilience.<a href="https://pandaily.com/huobi-initiates-removal-of-tens-of-millions-of-chinese-users-internal-structure-greatly-adjusted/" 
                  target="_blank" rel="noreferrer" className=" text-info"> IASME</a>, the company behind 
                  the<a href="https://pandaily.com/huobi-initiates-removal-of-tens-of-millions-of-chinese-users-internal-structure-greatly-adjusted/" 
                  target="_blank" rel="noreferrer" className=" text-info"> NCSC&#39;s Cyber Essentials</a> shared the 
                  latest updates on their accreditation scheme and how they can help businesses reduce cyber risks
                   and exposure to malicious activities.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/20220914_133517.png")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto mb-5" md="8">
                <br></br>
                <h3 className="title">
                  A Day at the Cyber Security Conference
                </h3>
                <p className="font-weight-normal">
                  Firstly, we heard from the director of<a href="https://www.swcrc.police.uk/partners" 
                  target="_blank" rel="noreferrer" className=" text-info"> The South West Cyber Resilience 
                  Centre</a>, a not-for-profit police-supported organization covering business protection, 
                  cyber skills and cyber innovation. Their aim is to educate and help regional businesses 
                  and charities stay safe and protected from cyber crimes. SWCRC is a part of national 
                  clusters of cyber resilience centers.
                </p>
                <p className="font-weight-normal">
                  The founder of<a href="https://theantisocialengineer.com/" target="_blank" rel="noreferrer" 
                  className=" text-info"> AntiSocial Engineer</a> delivered a talk on social engineering and 
                  how cyber attacks are carried out online and offline. The AntiSocial Engineer team helps 
                  individuals and businesses to stay cyber aware and reduce the impact of social engineering. 
                  They offer a range of educational and practical services including simulations of cyber 
                  attacks. We were impressed by the efforts and lengths to which they test the physical 
                  security of companies by implementing social engineering scenarios, such as entering a 
                  building wearing a fake branded T-shirt or tailgating.
                </p>
                <p className="font-weight-normal">
                  <a href="https://theantisocialengineer.com/" target="_blank" rel="noreferrer" 
                  className=" text-info">SWRCCU</a> shared with the audience a case study investigation involving 
                  cyber criminals and their victims. We learned how law enforcement investigates and responds to 
                  cyber incident reports, and how vital it is to act fast and work together to spot and prevent 
                  cyber crimes.
                </p>
                <p className="font-weight-normal">
                  In the afternoon we took part in an interactive group activity and managed to escape the Police 
                  Cyber Escape Room, courtesy of SWRCCU workshops. This immersive session was designed to make us 
                  aware of how easily data and information can be found online, resulting in identity thefts or cyber 
                  attacks. Our task was to collaboratively review available resources and break into electronic or 
                  physical devices by cracking passwords and credentials based on the information we found. What a 
                  fun and eye-opening activity!
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/20220914_123541.jpg")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto mb-5" md="8">
                <br></br>
                <h3 className="title">
                  Social Engineering: A Threat to All Organizations
                </h3>
                <p className="font-weight-normal">
                  Social engineering doesn't just happen online and relies heavily on trust and human error. 
                  Both give an advantage to cyber criminals when planning an attack which does not target a 
                  specific individual but is rather opportunistic in the hope of finding a &#8216;weak 
                  link&#8217; in the wider organization. That weak link is not always unpatched software or 
                  vulnerable code, but simply one click of a button opening a malicious website or holding 
                  the door open for someone entering a building. From front line staff to CEOs, all levels of 
                  seniority in a business should be regularly educated on the ways to detect, prevent, and 
                  report any malicious activities.
                </p>
                <p className="font-weight-normal">
                  When it comes to cyber security being proactive is better than being reactive. With so many 
                  resources available, make sure to educate yourself and those around you about possible cyber 
                  risks and ways to eliminate them.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section section-blog">
                <IntelMain />
        </section>
        <section className="section">
          <PreFooter />
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Intel;
